export default "__VITE_ASSET__BJXwUhna__"